import EmailActivityChat from './EmailActivityChat';

export default EmailActivityChat;
